<template>
  <div class="text-xs-center">
      <v-form ref="form">
        <v-layout wrap justify-center align-center>
          <v-flex xs12>
          <v-autocomplete
            ref="user"
            @keyup.native="keyupUsersSystem"
            @change="selectUser"
            @click="click"
            :rules="rules"
            :search-input.sync="search"
            :loading="loadingUsersSystem"
            :disabled="disabled"
            v-model="selectedUsers"
            :items="items"
            multiple
            chips
            :label="label ? label : 'Selecionar os participantes'"
            item-text="id_text"
            item-value="id"
            :filter="customFilter"
            return-object 
            style="margin-top: 0 !important; padding-top: 6px !important;"
          >
            <!-- color="blue-grey lighten-2" -->
            <template v-slot:selection="data">
              <v-chip v-if="data.item.id_text !== 'line' && data.item.id !== 'showMore'"
                :selected="data.selected"
                close
                @input="removeUser(data.item)"                        
              >
                <div class="selected-person">
                  <div class="selected-icon" style="margin-top: -6px !important;">
                    <img v-if="data.item.photo_path" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar">
                    <div v-else class="avatar_user">
                      <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                    </div>
                  </div>
                  <div class="person-company-info">
                    {{ data.item.id_text }}
                  </div>
                </div>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="data.item.id_text === 'line'">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </template>
              <template v-else-if="data.item.id === 'showMore'">
                <div class="text-xs-center show-more">
                  <v-progress-circular v-if='loadingMoreTasks' :size="20" :width="3" indeterminate color="primary"></v-progress-circular>
                  <span v-else><strong>Mostrar mais</strong></span>
                </div>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                <div>
                  <img dark v-if="data.item.photo_path" class="avatar_image teal_border" :src="`${basePath}uploads/users/${data.item.photo_path}`" alt="avatar">
                  <div dark v-else class="avatar_user teal_border">
                    <h3>{{getFirstLetters(data.item.id_text)}}</h3>
                  </div>
                </div>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.id_text"></v-list-tile-title> 
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
  // desabilita para poder fazer a verificação sem precisar ter a tipagem certa
  /* eslint-disable eqeqeq */
  import general from '../../mixin/general'
  import rules from './../../mixin/rules'
  import access from './../../mixin/access'

  export default {
    name: 'PUserIllisSystem',
    mixins: [access, general, rules],
    props: [ 'value', 'rules', 'label', 'disabled', 'itemsNotShow' ],
    data () {
      return {
        basePath: process.env.API,
        loadingUsersSystem: false,
        loadingMoreTasks: false,
        usersSystem: [],
        items: [],
        qtdMoreTask: 1,
        setKeyup: null,
        search: '',
        selectedUsers: []
      }
    },
    mounted () {
      this.loadingUsersSystem = true
      // Já busca 25 primeiros usuários
      this.getUsersSystem()
    },
    methods: {
      click () {
        this.$emit('click')
      },
      focus () {
        this.$nextTick(() => this.$refs.user.focus())
      },
      validate () {
        return (this.$refs.form && this.$refs.form.validate())
      },
      keyupUsersSystem () {
        clearTimeout(this.setKeyup)
        this.loadingUsersSystem = true
        this.mountItem()
        this.setKeyup = setTimeout(() => {
          this.qtdMoreTask = 1
          this.getUsersSystem()
        }, 2000)
      },
      removeUser (item) {
        this.selectedUsers.splice(this.selectedUsers.findIndex((val) => {
          return val.id === item.id
        }), 1)
        this.$emit('input', this.selectedUsers)
      },
      getUsersSystem () {
        this.loadingMoreTasks = true
        this.$http.get(`api/get_users_system?qtd=${this.qtdMoreTask || 1}&search=${this.search || ''}`).then((res) => {
          this.usersSystem = res.body
          this.loadingMoreTasks = false
          this.loadingUsersSystem = false
          this.mountItem()
        })
      },
      selectUser (val) {
        setTimeout(() => {
          let showMore = false
          if (typeof val === 'undefined') {
            this.selectedUsers = null
          } else if (Array.isArray(val)) {
            showMore = (val[val.length - 1]['id'] === 'showMore')
            // Se for array verifica verifica se n foi clicado na linha de showMore, se tiver sido tira ela
            if (val.find((v) => { return v.id === 'showMore' })) this.removeUser(val.find((v) => { return v.id === 'showMore' }))
            // Se for array verifica verifica se n foi clicado na linha de carregamento, se tiver sido tira ela
            if (val.find((v) => { return v.id_text === 'line' })) this.removeUser(val.find((v) => { return v.id_text === 'line' }))
          }
          if (showMore) {
            this.qtdMoreTask++
            this.getUsersSystem()
          } else {
            // MOnta novamente a lista de itens
            this.$emit('input', this.selectedUsers)
            this.mountItem()
            this.search = ''
          }
        }, 10)
      },
      // Usado para não usar o filtro do componente autocomplete
      customFilter (item, queryText, iText) {
        let itemText = item.id_text + ' ' + item.email
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(search) > -1 || item['type'] == 0
      },
      mountItem () {
        // foi incluido o id: 0 para eles passarem pelo filtro e mostrar quando o usuário filtra
        this.items = [{ id: 'header1', type: 0, header: 'Usuários' }]
        Array.prototype.push.apply(this.items, [{ id: 'divider', type: 0, divider: true }])
        if (this.loadingUsersSystem) Array.prototype.push.apply(this.items, [{ id: 'line', type: 0, id_text: 'line' }])
        // Variavel criada para armazenar os valores que estão selecionados e não tira los da lista, necessario quando vai ed
        var selectedUsers = []
        // CAso tenha valores selecionados que devido ao filtro não estão na lista, adiciona-los manualmente
        if (this.selectedUsers !== null) {
          if (Array.isArray(this.selectedUsers) && this.selectedUsers.length > 0) {
            this.selectedUsers.map((user) => {
              if (!this.usersSystem.some((val) => { return user.id === val.id })) {
                this.usersSystem.unshift(user)
                selectedUsers.unshift(user.id)
              }
            })
          } else if ((typeof this.selectedUsers) === 'object' && this.selectedUsers.hasOwnProperty('id')) {
            if (this.selectedUsers.company_id !== this.company_id && !this.usersSystem.some((val) => { return this.selectedUsers.id === val.id })) {
              this.usersSystem.unshift(this.selectedUsers)
              selectedUsers.unshift(this.selectedUsers.id)
            }
          }
        }
        Array.prototype.push.apply(this.items, JSON.parse(JSON.stringify(this.usersSystem || [])))
        if ((this.qtdMoreTask * 25) <= this.usersSystem.length) {
          Array.prototype.push.apply(this.items, [{ id: 'showMore', type: 0, id_text: 'Mostrar mais' }])
        }
        Array.prototype.push.apply(this.items, [{ id: 'search', type: 0, header: 'Digite para encontrar usuários no illis' }])
        // filtra os itens que não são pra ser mostrados, como itens que já foram adicionados
        if (this.itemsNotShow) {
          this.items = this.items.filter((item) => {
            return !this.itemsNotShow.some((id) => { return id === item.id && selectedUsers && !selectedUsers.includes(id) })
          })
        }
      }
    },
    watch: {
      // caso o usuário de fora sejá alterado, tbm alterar o do pUserSystem
      value: {
        immediate: true,
        handler (val, oldVal) {
          if (val != this.selectedUsers) {
            this.selectedUsers = val
            this.mountItem()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .avatar_image{
    height: 38px;
    width: 38px;  
  }

  .avatar_user{
    background: #00acc2;
    border-radius: 50%;
    height: 38px;
    width: 38px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .company-image{
    height: 15px;
    width: 15px;
  }

  .company-icon{
    height: 15px;
    width: 15px;
    color: #00acc2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .teal_border{
    border: 2px solid #00acc2;
  }

  .grey_border{
    border: 4px solid #888;
  }

  .yellow_border{
    border: 4px solid #ece92c;
  }

  .green_border{
    border: 4px solid #15df03;
  }

  .v-chip--selected{
    box-shadow:none;
  }

  .v-chip--selected::after{
    background: none;
  }
  
  .selected-person{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    padding-bottom: 5px;
  }

  .selected-icon{
    margin-right: 6px;
  }

  .selected-icon img{
    height: 28px;
    width: 28px;
    border-radius: 50%;
  }

  .selected-icon .avatar_user{
    height: 28px;
    width: 28px;
  }

  .person-company-info{
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .selected-company-info{
    display: flex;
  }

  .selected-company-info img{
    width: 14px;
    height: 14px;
    border-radius: 5px;
  }

  .selected-company-info .avatar-chip-connection,
  .selected-company-info .text{
    margin-right: 6px;
    color: #00acc2;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PUserIllisSystem.vue